import React from "react";
import "./PillarsIslam.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
const PillarsIslam = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <section>
      <div class="Pillars">
        <h2>
          {rtl
            ? "أركان الإسلام"
            : fr
            ? "Piliers de l'ISLAM"
            : "Pillars of Islam"}
        </h2>
        <img
          src={require("../../Assets/pshape.png")}
          alt=""
          class="pillars-shape"
        />
        <div class="lft-shp shp-lyr"></div>
        <div class="container">
          <div class="plrs-wrap text-center remove-ext5">
            <div
              class="row"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div class="col-md-3 col-sm-6 col-lg-2  ">
                <Link to="/five-pillars-shahada">
                  <div class="plr-box ">
                    <i class="flaticon-clicker"></i>
                    <div class="pilr-info">
                      <h4>{rtl ? "الشهادتان" : "Shahadah"}</h4>
                      <p>({rtl ? "ايمان" : fr ? "La foi" : "Faith"})</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div class="col-md-3 col-sm-6 col-lg-2 ">
                <Link to="/five-pillars-prayer">
                  <div class="plr-box">
                    <i class="flaticon-islamic-pray"></i>
                    <div class="pilr-info">
                      <h4>{rtl ? "إقامِ الصلاةِ" : "Salah"}</h4>
                      <p>({rtl ? "صلاة" : fr ? "Prière" : "Prayer"})</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div class="col-md-3 col-sm-6 col-lg-2 ">
                <Link to="/five-pillars-fasting">
                  <div class="plr-box">
                    <i class="flaticon-islamic-ramadan"></i>
                    <div class="pilr-info">
                      <h4>{rtl ? "صومِ رمضانَ" : "Sawm"}</h4>
                      <p>({rtl ? "صوم" : fr ? "Le jeûne" : "Fasting"})</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div class="col-md-3 col-sm-6 col-lg-2 ">
                <Link to="/five-pillars-zakat">
                  <div class="plr-box">
                    <i class="flaticon-charity"></i>
                    <div class="pilr-info">
                      <h4>{rtl ? "إيتاءِ الزّكاةِ" : "Zakat"}</h4>
                      <p>({rtl ? "الصدقة" : fr ? "L'aumône" : "Almsgiving"})</p>
                    </div>
                  </div>
                </Link>
              </div>
              <div class="col-md-3 col-sm-6 col-lg-2 ">
                <Link to="/five-pillars-pilgrimage">
                  <div class="plr-box">
                    <i class="flaticon-kaaba-building"></i>
                    <div class="pilr-info">
                      <h4>{rtl ? "الحجِّ" : "Hajj"}</h4>
                      <p>({rtl ? "حج" : fr ? "Pèlerinage" : "Pilgrimage"})</p>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PillarsIslam;
